import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PatientsPage } from './patients';
import { TranslateModule } from '@ngx-translate/core'; // Required for translation.
import { DirectivesModule } from '../../directives/directives.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  declarations: [
    PatientsPage
  ],
  imports: [
    IonicPageModule.forChild(PatientsPage),
    TranslateModule.forChild(), // Required for translation.
    DirectivesModule,
    NgxDatatableModule
  ],
})
export class PatientsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/patients/patients.module.ts